// import React from "react";
// import { Box, Card, CardContent, Typography, Grid2 } from "@mui/material";
// import { clients } from "./data";

// const ClientCards = () => {
//   return (
//     <Box
//       sx={{
//         py: { xs: 3, sm: 4, md: 5, lg: 6, xl: 7 }, // Responsive padding top/bottom
//         px: { xs: 1, sm: 2, md: 3, lg: 4, xl: 5 }, // Responsive padding left/right
//       }}
//     >
//       <Grid2 container spacing={3} justifyContent="center">
//         {clients.map((company) => (
//           <Grid2 item key={company.id} xs={12} sm={12} md={6} lg={4} xl={3}>
//             <Card
//               sx={{
//                 textAlign: "center",
//                 borderRadius: 3,
//                 p: 3,
//                 border: "1px solid rgba(56, 55, 55, 0.2)",
//                 boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
//                 transition: "0.3s",
//                 "&:hover": { boxShadow: "2px 6px 25px rgba(0,0,0,0.15)" },
//                 display: "flex",
//                 flexDirection: "column",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 minHeight: "160px", // Increased height for better spacing
//                 width: "85%",
//               }}
//             >
//               <Box
//                 sx={{
//                   display: "flex",
//                   justifyContent: "center",
//                   alignItems: "center",
//                   flexGrow: 1,
//                   width: "100%",
//                 }}
//               >
//                 <Box
//                   component="img"
//                   src={company.logo}
//                   alt="logo"
//                   sx={{
//                     width: "70%",
//                     maxHeight: "70px",
//                     objectFit: "contain",
//                   }}
//                   justifySelf={"center"}
//                 />
//               </Box>
//               <CardContent sx={{ width: "100%" }}>
//                 <Typography
//                   variant="h6"
//                   fontWeight="bold"
//                   gutterBottom
//                   sx={{
//                     fontFamily: "Light",
//                     fontSize: { xs: 10, sm: 11, md: 14, lg: 18, xl: 20 },
//                     fontWeight: "500",
//                     lineHeight: "1.3",
//                     color: "#0A3161",
//                     overflow: "hidden",
//                     textOverflow: "ellipsis",
//                     whiteSpace: "normal", // Allow multiline text
//                   }}
//                 >
//                   {company.name}
//                 </Typography>
//                 <Typography
//                   variant="body2"
//                   sx={{
//                     fontFamily: "Light",
//                     fontSize: { xs: 12, sm: 12, md: 12, lg: 12, xl: 14 },
//                     fontWeight: "500",
//                     lineHeight: "1.3",
//                     color: "#333333",
//                     overflow: "hidden",
//                     textOverflow: "ellipsis",
//                     whiteSpace: "normal", // Allow multiline text
//                   }}
//                 >
//                   {company.tagline}
//                 </Typography>
//               </CardContent>
//             </Card>
//           </Grid2>
//         ))}
//       </Grid2>
//     </Box>
//   );
// };

// export default ClientCards;

import React from "react";
import { Box, Card, CardContent, Typography, Grid } from "@mui/material";
import { clients } from "./data";

const ClientCards = () => {
  return (
    <Box
      sx={{
        py: { xs: 3, sm: 4, md: 5, lg: 2, xl: 2 },
        px: { xs: 1, sm: 2, md: 3, lg: 2, xl: 2 },
      }}
    >
      <Typography
        sx={{
          color: "#002367",
          fontFamily: "Light",
          fontSize: { xs: 24, sm: 32, md: 42 }, // Responsive font size
          fontWeight: "700",
          lineHeight: "35px",
          display: "flex",
          justifyContent: "center",
          marginTop: 8,
          marginBottom: 4,
        }}
      >
        Our Valuable Clients
      </Typography>
      <Grid container spacing={3} justifyContent="center">
        {clients.map((company) => (
          <Grid item key={company.id} xs={12} sm={6} md={4} lg={4} xl={3}>
            <Card
              sx={{
                textAlign: "center",
                borderRadius: 3,
                p: 2,
                border: "1px solid rgba(56, 55, 55, 0.2)",
                boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                transition: "0.3s",
                "&:hover": { boxShadow: "2px 6px 25px rgba(0,0,0,0.15)" },
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "center",
                minHeight: "160px",
                flexGrow: 1, // Allow the card to grow and fill the space
                flexBasis: 0, // Ensure all cards take equal width
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexGrow: 1,
                  width: "100%",
                }}
              >
                <Box
                  component="img"
                  src={company.logo}
                  alt="logo"
                  sx={{
                    width: "70%",
                    maxHeight: "60px",
                    objectFit: "contain",
                  }}
                />
              </Box>
              <CardContent sx={{ width: "100%" }}>
                <Typography
                  variant="h6"
                  fontWeight="bold"
                  gutterBottom
                  sx={{
                    fontFamily: "Light",
                    fontSize: { xs: 12, sm: 14, md: 16, lg: 18, xl: 20 },
                    fontWeight: "500",
                    lineHeight: "1.3",
                    color: "#0A3161",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "normal",
                  }}
                >
                  {company.name}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontFamily: "Light",
                    fontSize: { xs: 11, sm: 11, md: 12, lg: 12, xl: 14 },
                    fontWeight: "500",
                    lineHeight: "1.3",
                    color: "#333333",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "normal",
                  }}
                >
                  {company.tagline}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ClientCards;
